import {
    mapMutations, mapActions, mapState,
} from 'vuex'
import * as T from '@common/store/types'
import { WORKSPACE } from '@common/store/module-types'
import { GET_WORKSPACE_LIST } from '@common/store/workspace/types'
import { bus } from '@utils/event'
// eslint-disable-next-line
import {
    Menu,
    // Setting,
    // Breadcrumb,
} from './components'

export default {
    data() {
        return {
            inited: false,
        }
    },
    computed: {
        ...mapState(WORKSPACE, ['current']),
        showBread() {
            const { meta = {} } = this.$route
            return !!meta.title
        },
        globalLoading() {
            return this.$store.state.modeling.globalLoading
        },
    },
    async created() {
        await this.initApp()
        this.inited = true

        bus.$on('change_work_space', this.resetApp)
        bus.$on('change_bus_env', this.updateAppInfo)
        this.$EMULATOR_EVENT.$on('UPDATE_ROLE', this.updateRole)
    },
    beforeDestroy() {
        bus.$off()
    },
    methods: {
        ...mapMutations({
            cacheCookies: T.CACHE_COOKIES,
            UPDATE_LOADING: T.UPDATE_LOADING,
        }),
        ...mapActions(WORKSPACE, {
            GET_WORKSPACE_LIST,
            REFRESH_TOKEN: T.REFRESH_TOKEN,
        }),
        updateRole() {
            this.$store.dispatch('GET_CONF_LIST')
        },
        getBranches(appId, workspaceId) {
            this.GET_WORKSPACE_LIST({
                appId,
                workspaceId,
                pageSize: 10,
                page: 1,
                workspaceName: '',
            })
        },
    },
    render() {
        if (!this.inited) return null
        return (
            <div id="app">
                <hc-container class="app-emulator-wrap">
                    <hc-header
                        class="emulator-header"
                        height="52px"
                    >
                        {/** emulator 中 name 为 TopbarLeft 的组件**/}
                        <div class="header-left">
                            {
                                <TopbarLeft /> //NOSONAR
                            }
                        </div>
                        <hc-container vLoading={this.globalLoading} class="header-center">
                            <Menu />
                        </hc-container>
                        <div class="header-right">
                            {/** emulator 中 name 为 TopbarRight 的组件**/}
                            {/* <TopbarRight /> */}
                            {
                                <Btns></Btns> //NOSONAR
                            }
                        </div>
                    </hc-header>
                    <hc-main class="emulator-container" vLoading={this.globalLoading}>
                        {/* <hc-main class='app-main'> */}
                        <div
                            class="emulator-container__wrapper"
                        >
                            {/* <keep-alive exclude={['ObjectEntry', 'ServiceEntry', 'Setting', 'AlterComponents', 'RoleAuth']}> */}
                            <router-view />
                            {/* </keep-alive> */}
                        </div>
                        {/* </hc-main> */}
                    </hc-main>
                    {
                        // tag: hideBottom
                        // 页面设计页且应用内无页面时
                        // this.showBottom
                        //     ?
                        // <hc-footer height="40px" class="emulator-footer">
                        //     {/** emulator 中 name 为 BottomPanel 的组件**/}
                        //     {
                        //         <BottomPanel></BottomPanel> //NOSONAR
                        //     }
                        // </hc-footer>
                        // : null
                    }
                </hc-container>
                {
                    this.renderDevTools && this.renderDevTools()
                }
            </div>
        )
    },
}
